import Grid2 from "@mui/material/Unstable_Grid2";
import { Alert, Button, useTheme } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/system";

interface IWorkTimeBottomBar {
    acceptAllButtonPress: () => void;
    acceptDisabled: boolean;
    costCenterFilterActive: boolean;
}

export function WorkTimeBottomBar(props: IWorkTimeBottomBar) {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Box>
            <Grid2 container alignItems="center" spacing={1}>
                {props?.costCenterFilterActive &&
                    <Grid2>
                        <Alert variant="filled" severity="info">
                            {t("workTime.costCenterAcceptDisabled")}
                        </Alert>
                    </Grid2>
                }
                <Grid2>
                    <Button
                        color="secondary"
                        sx={{
                            color: theme.palette.common.white,
                            "&.Mui-disabled": {
                                backgroundColor: theme.palette.grey[300],
                                color: theme.palette.grey[400],
                            }
                        }}
                        variant={"contained"}
                        onClick={props.acceptAllButtonPress}
                        disabled={props.acceptDisabled}
                        size="small"
                    >
                        {t("workTime.saveSalaries")}
                    </Button>
                </Grid2>
            </Grid2>
        </Box>
    );
}
